import axios from './axios'
import { Diagnosi  } from '@/../../EshJSLib/models/patient'

export async function fetchDiagnosi(id : number) {
  
    const response = await axios.get(`/api/diagnosiPatient/${id}`);
    return response.data;
 }
 

export async function deletePatient(id: number) {
   const response = await axios.delete(`/api/diagnosi/${id}`);
    return response.data;
}

export async function updateDiagnosi(params:Diagnosi) {
    const response = await axios.put(`/api/diagnosi/${params.id_diagnosi}`,params);

    return response.data;
}



